/**
 * useVariations - Hook for image variation generation
 * useVariationsPricing - Hook for DB-driven pricing
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  generateVariations,
  getVariationsPricing,
  type VariationParams,
  type VariationResult,
  type VariationPricing,
} from '@/lib/api/variations';

export function useVariations() {
  const queryClient = useQueryClient();

  return useMutation<VariationResult, Error, VariationParams>({
    mutationFn: generateVariations,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['gallery-v2'] });
    },
  });
}

export function useVariationsPricing() {
  return useQuery<VariationPricing>({
    queryKey: ['variations-pricing'],
    queryFn: getVariationsPricing,
    staleTime: 5 * 60 * 1000, // 5 min cache
  });
}
